export default __webpack_public_path__ + "static/doctor-1-22e25f67d1c9e626e9b909733f0dbbf4.png";